import React, { Component } from 'react'

import { SettingsTitle, SettingsRow } from '../StyledComponents/Settings'

class SettingsRowText extends Component {
    render() {
        const { title, isFirst } = this.props

        return (
            <SettingsRow isFirst={isFirst}>
                <SettingsTitle className="align-top col">{title}</SettingsTitle>
            </SettingsRow>
        )
    }
}

SettingsRowText.defaultProps = {
    title: '-',
}

export default SettingsRowText



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsRowText.js